import { useQuery } from '@tanstack/react-query';
import { UPLOADS_QUERY_KEY } from './key';
import { fetchUploads } from './request';

export const useUploads = (enabled = true) =>
  useQuery({
    queryKey: [UPLOADS_QUERY_KEY],
    queryFn: fetchUploads,
    enabled,
  });
